module.exports = __webpack_public_path__ + "img/ana_lopes.b9f3d36a.jpeg";